var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenplayEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3BCC9C",
    d: "M32,0c17.7,0,32,14.3,32,32S49.7,64,32,64S0,49.7,0,32S14.3,0,32,0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M41.8,10l8.2,7.8v34.8c0,0.8-0.7,1.4-1.5,1.4h-33c-0.8,0-1.5-0.6-1.5-1.4V11.4c0-0.8,0.7-1.4,1.5-1.4 H41.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#D3D5DD",
    points: "50,17.8 41.8,17.8 41.8,10  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F26DA0",
    d: "M49.8,23.1L54,19c0.8-0.8,2-0.8,2.8,0l4.2,4.2c0.8,0.8,0.8,2,0,2.8l-4.1,4.2L49.8,23.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#C1DCF7",
    points: "58,29 56.9,30.2 55.4,28.6 56.5,27.5 58,29  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#9FBAD1",
    points: "56.5,27.5 55.4,28.6 51.4,24.6 52.5,23.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#C1DCF7",
    points: "50,22.9 51,22 51,22 52.5,23.5 51.4,24.6 49.8,23.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3D5DD",
    d: "M43,21c0.5,0,1,0.5,1,1s-0.5,1-1,1H19c-0.6,0-1-0.5-1-1s0.4-1,1-1H43z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8C6AA",
    points: "34,42 38,46 38,49 34,49 31,46 31,42  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3D5DD",
    d: "M36.8,16c0.5,0,1,0.5,1,1s-0.5,1-1,1H19c-0.6,0-1-0.5-1-1s0.4-1,1-1H36.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3D5DD",
    d: "M34,26c0.5,0,1,0.5,1,1s-0.5,1-1,1H19c-0.6,0-1-0.5-1-1s0.4-1,1-1H34z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "34,49 31,49 31,46  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26,47c0.5,0,1,0.5,1,1s-0.5,1-1,1h-7c-0.6,0-1-0.5-1-1s0.4-1,1-1H26z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F4A845",
    points: "56.9,30.2 38,49 38,46 34,42 31,42 31,41.9 49.8,23.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F7D854",
    points: "55.4,28.6 38,46 34,46 34,42 51.4,24.6  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenplayEdit);
export default __webpack_public_path__ + "static/media/screenplay-edit.7372b127858824f955a7441defd37542.svg";
export { ForwardRef as ReactComponent };